// extracted by mini-css-extract-plugin
export default {"link":"dashboardPage_link__jeKF7","noRoleMsg":"dashboardPage_noRoleMsg__+pkGY"};